import { z } from 'zod';
import { LOOK, NameSchema, about, sourceOf } from '../schema_fields.ts';

// The solar tile: what the house uses and where it comes from, panels, battery and grid.

/** How the tile draws (tiles spec SO-2): the quiet cross, or the legacy app's drawing. */
export const SOLAR_DESIGNS = ['quiet', 'classic'] as const;

const solarQuantity = (label: string, description: string) => sourceOf(NameSchema.optional(), { gives: ['number'], label }, description);

/** Each option names the tile's source for one quantity; a missing one shows as no data. */
export const SolarOptionsSchema = z.object({
    load: solarQuantity('Use', 'what the house uses, in W'),
    pv: solarQuantity('Solar panels', 'what the panels give, in W'),
    batteryCharge: solarQuantity('Battery charge', 'out of the battery (or into it, below 0), in W'),
    grid: solarQuantity('Grid', 'from the grid (or to it, below 0), in W'),
    gridVoltage: solarQuantity('Grid voltage', 'in V'),
    batterySoc: solarQuantity('Battery level', 'in %'),
    design: z.enum(SOLAR_DESIGNS).default('quiet').meta({
        ...LOOK,
        ...about('Design', 'how the flows are drawn'),
        'x-labels': { quiet: 'Quiet cross', classic: 'Classic' },
    }),
});
